import { Component, Vue } from 'vue-property-decorator';
import { Header as AppHeader } from '@coreui/vue';
import { TelstraUIVueSvg, TelstraUIVueUserHeader } from '@/external/telstra-ui-vue/components';
import { AppStoreModule } from '@/store';
import AppStore from '@/store/modules/AppStoreModule';

@Component({
  components: {
    AppHeader,
    TelstraUIVueUserHeader,
    TelstraUIVueSvg,
  },
})
export default class TelstraUIVueHeader extends Vue {
  app$: AppStore = AppStoreModule;

  toggleSideNav() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.app$.toggleIsDrawerOpen();
      this.app$.minifySidenav();
    } else {
      this.app$.toggleIsSidenavMini();
      this.app$.closeDrawer();
    }
  }
}
